"use client";
import dynamic from 'next/dynamic';

import React, { Fragment } from "react";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });
import { Menu, Transition } from "@headlessui/react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { useAuth } from "@/contexts/authContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/custom/ui/tooltip'

const ProfileLabel = (user) => {
  return (
    <div className="flex items-center">
      <div className="flex-1">
        <div className={`lg:h-16 lg:w-16 h-12 w-12 rounded-full ${user?.mxs_pass ? 'ring-2 ring-yellow-500 shadow-lg shadow-yellow-500/20' : 'border-2 border-metaxseed-gray'} bg-metaxseed-black relative`}>
          <Image src={user ? (user.photo_url ? user.photo_url : "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf") : "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"} alt="user-profile-image" width={370} height={411} className="block w-full h-full object-cover rounded-full" style={{ scale: "1.01" }} />
          
          {/* Add a gradient overlay for premium users */}
          {user?.mxs_pass && (
            <div className="absolute inset-0 rounded-full ring-2 ring-yellow-500 bg-gradient-to-r from-yellow-500 to-orange-500 opacity-0"></div>
          )}
          
          {/* MXS Pass Crown - no tooltip */}
          {user?.mxs_pass && (
            <div className="absolute -top-2 -right-2 group">
              {/* Professional crown badge */}
              <div className="relative">
                {/* Main container */}
                <div className="relative bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full p-0.5 shadow-lg shadow-yellow-500/20">
                  {/* Inner container */}
                  <div className="bg-metaxseed-black rounded-full p-1 relative">
                    {/* Crown icon */}
                    <Icon
                      icon="mdi:crown"
                      className="text-yellow-500 w-4 h-4 relative z-10"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex-none text-zinc-600 dark:text-white text-sm font-normal items-center lg:flex hidden overflow-hidden text-ellipsis whitespace-nowrap">
        <div className="overflow-hidden text-ellipsis whitespace-nowrap w-full block"></div>
      </div>
    </div>
  );
};

const Profile = ({ searchModalClicked, tokenAllocationSearchClicked }) => {
  const { isAuthenticated, isFetchingUser, isWalletConnecting, user, walletAddress, logout } = useAuth();

  const router = useRouter();

  const ProfileMenu = [
    {
      label: "My Profile",
      icon: "heroicons-outline:user",
      action: () => {
        router.push("/profile");
      },
    },
    {
      label: "My Accounts",
      icon: "carbon:account",
      action: () => {
        router.push("/accounts");
      },
    },
    {
      label: "My Reports",
      icon: "mdi:report",
      action: () => {
        router.push("/report");
      },
    },
    {
      label: "Search Node",
      icon: "mdi:search",
      action: () => {
        searchModalClicked();
      },
    },
    // {
    //   label: "Token Allocation",
    //   icon: "mdi:file-search",
    //   action: () => {
    //     tokenAllocationSearchClicked();
    //   },
    // },
    {
      label: "Logout",
      icon: "heroicons-outline:login",
      action: () => {
        logout();
      },
    }
  ];

  return (
    <div className="relative inline-block">
      <Menu as="div" className="block w-full">
        <Menu.Button className="block w-full">
          <div>{ProfileLabel(user)}</div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className="absolute ltr:right-0 rtl:left-0 origin-top-right border-2 border-metaxseed-gray bg-metaxseed-black
            rounded shadow-dropdown z-[9999] gothamMedium font-normal w-[180px] top-[72px]"
          >
            <div>
              {ProfileMenu.map((item, index) => (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <div 
                      onClick={() => item.action()}
                      className={`${active ? " bg-metaxseed-gray bg-opacity-50 text-white" : " text-metaxseed-text-gray"} block cursor-pointer ${index === ProfileMenu.length - 1 ? "border-t border-metaxseed-gray mt-4" : ""} ${item.hasDivider ? "border-t border-slate-700" : ""}`}
                    >
                      <div className="block px-4 py-2">
                        <div className="flex items-center">
                          <span className="block text-xl ltr:mr-3 rtl:ml-3">
                            <Icon icon={item.icon} />
                          </span>
                          <span className="block text-sm">{item.label}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default Profile;
